// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from "element-ui/src/locale/lang/en";
import './assets/common.less'
import dataV from '@jiaminghi/data-view'
import VueI18n from "vue-i18n"
import zh from './lang/zh'
import en from './lang/en'
import BaiduMap from 'vue-baidu-map'
import echarts from 'echarts'
import Popup from './components/popup/dialog'
import timeDialog from "./components/popup/timeDialog";
import switchSetDialog from "./components/popup/switchSetDialog";
import parameterSetDialog from "./components/popup/parameterSetDialog";
import './until/flexible';
import commonFun from "./tool/commonFun";
import App from './App'
import router from './router'
Vue.prototype.$popup = Popup.install;
Vue.prototype.$timeDialog = timeDialog.install;
Vue.prototype.$switchSetDialog = switchSetDialog.install;
Vue.prototype.$parameterSetDialog = parameterSetDialog.install;
Vue.prototype.$echarts = echarts;
Vue.prototype.$commonFun = commonFun;

Vue.use(dataV);
if(localStorage.getItem('locale') === 'en-US'){
  Vue.use(ElementUI,{locale});
} else {
  Vue.use(ElementUI);
}

Vue.use(VueI18n);

Vue.use(BaiduMap, {
  ak: 'qTlwZrgnkMhdiTYqJ9yAABAROAfEsquY'
})


const i18n = new VueI18n({
  // locale:'zh-CN',
  locale: localStorage.getItem('locale'),
  messages: {
    'zh-CN': zh,
    'en-US': en
  },
  silentTranslationWarn: true
})

Vue.config.productionTip = false;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js